export function formatDateRange(startDate, endDate, options = {}) {
  const {
    locale = "de",
    showTime = true,
    showYear = true,
    allDay = false,
  } = options;

  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : null;

  if (Number.isNaN(start.getTime())) return "";

  const validEnd =
    end && !Number.isNaN(end.getTime()) && end.getTime() >= start.getTime()
      ? end
      : null;

  const intlLocale = locale === "de" ? "de-DE" : "en-US";

  const dateFormatter = new Intl.DateTimeFormat(intlLocale, {
    day: "2-digit",
    month: "short",
    ...(showYear ? { year: "numeric" } : {}),
  });

  const timeFormatter = new Intl.DateTimeFormat(intlLocale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const formatTime = (date) => {
    const time = timeFormatter.format(date).replace(":", ".");
    return `${time}`;
  };

  const startDateStr = dateFormatter.format(start);
  const startTimeStr = showTime && !allDay ? formatTime(start) : "";

  // Case 1: no valid end date
  if (!validEnd) {
    if (showTime && !allDay) {
      return `${startDateStr} ${startTimeStr} Uhr`;
    }
    return startDateStr;
  }

  const endDateStr = dateFormatter.format(validEnd);
  const endTimeStr = showTime && !allDay ? formatTime(validEnd) : "";

  const sameDay = start.toDateString() === validEnd.toDateString();

  // Case 2: same day
  if (sameDay) {
    if (showTime && !allDay) {
      return `${startDateStr} (${startTimeStr}–${endTimeStr} Uhr)`;
    }
    return startDateStr;
  }

  // Case 3: different days
  if (showTime && !allDay) {
    return `${startDateStr} – ${endDateStr} (${startTimeStr}–${endTimeStr} Uhr)`;
  }

  return `${startDateStr} – ${endDateStr}`;
}
